import { Navigate } from "react-router-dom"
import { ReactNode } from "react"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useIsMatsuriCleaner } from "@/hooks/useCompanyType"
import { useCleanerProfile } from "@/hooks/useApprovalRequest"
import { LoadingMessage } from "@/components/LoadingMessage/LoadingMessage"

/**
 * matsuri所属かつstaff_code(Payme社員コード)を持つ清掃員のみアクセスできるページのガード。
 * 対象外の清掃員が直接URLを開いた場合はスケジュール画面へ戻す。
 */
export const MatsuriCleanerGuard = ({ children }: { children: ReactNode }) => {
    const isMatsuriCleaner = useIsMatsuriCleaner()

    if (!isMatsuriCleaner) {
        return <Navigate to="/schedule" replace />
    }

    return <StaffCodeGuard>{children}</StaffCodeGuard>
}

const StaffCodeGuard = ({ children }: { children: ReactNode }) => {
    const { token } = useAuth()
    const { data: profile, isLoading } = useCleanerProfile(token)

    if (isLoading) {
        return <LoadingMessage />
    }

    if (!profile?.staffCode) {
        return <Navigate to="/schedule" replace />
    }

    return <>{children}</>
}
